export const WalletEvents = {
    accountChanged: 'accountChanged',
    networkChanged: 'networkChanged',
    connect: 'connect',
    disconnect: 'disconnect',
};
//# sourceMappingURL=iwallet.js.map